import { useLocation, useNavigate } from 'react-router-dom';

import { useExpenseSheet } from '../../features/expenses/SheetProvider';
import { useIncomeSheet } from '../../features/income/SheetProvider';
import {
  useAssetSheet,
  useCategorySheet,
  useGoalSheet,
} from '../../features/quickCreate/SheetProviders';
import pt from '../../locales/pt';
import { paths } from '../../routes/paths';

function underPath(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(prefix + '/');
}

/**
 * Returns the FAB action and label for the current route.
 * Falls back to the generic QuickActionsSheet on unrecognised routes.
 */
export function useFABAction(openQuickActions) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { open: openExpense } = useExpenseSheet();
  const { open: openIncome } = useIncomeSheet();
  const { open: openCategory } = useCategorySheet();
  const { open: openAsset } = useAssetSheet();
  const { open: openGoal } = useGoalSheet();

  if (underPath(pathname, paths.expenses))
    return { action: openExpense, label: pt.nav.quickActionsExpense };

  if (pathname === paths.incomeSources)
    return {
      action: () => navigate(`${paths.incomeSources}?create=1`),
      label: pt.nav.quickActionsIncomeSource,
    };

  if (underPath(pathname, paths.income))
    return { action: openIncome, label: pt.nav.quickActionsIncome };

  if (underPath(pathname, paths.categories))
    return { action: openCategory, label: pt.nav.quickActionsCategory };

  if (underPath(pathname, paths.goals))
    return { action: openGoal, label: pt.nav.quickActionsGoal };

  if (underPath(pathname, paths.ativos) || underPath(pathname, paths.patrimonio))
    return { action: openAsset, label: pt.nav.quickActionsAsset };

  return { action: openQuickActions, label: pt.nav.quickActions };
}
